import { IntrospectionQuery } from 'graphql';
import introspectionResult from 'graphql.schema.json';

/**
 * Generate possibleTypes from GraphQL introspection for Apollo Client
 * This enables proper fragment matching and improves cache performance
 * Based on: https://www.apollographql.com/docs/react/data/fragments#defining-possibletypes-manually
 */
function generatePossibleTypes(introspectionData: IntrospectionQuery) {
  const possibleTypes: Record<string, string[]> = {};

  introspectionData.__schema.types.forEach(supertype => {
    if (supertype.kind === 'UNION' || supertype.kind === 'INTERFACE') {
      const possibleTypesForSupertype = introspectionData.__schema.types
        .filter(
          type =>
            type.kind === 'OBJECT' &&
            type.interfaces?.some(
              interfaceType => interfaceType.name === supertype.name
            )
        )
        .map(type => type.name);

      if (supertype.kind === 'UNION') {
        possibleTypes[supertype.name] =
          supertype.possibleTypes?.map(type => type.name) || [];
      } else if (possibleTypesForSupertype.length > 0) {
        possibleTypes[supertype.name] = possibleTypesForSupertype;
      }
    }
  });

  return possibleTypes;
}

// Generate possibleTypes from introspection data
export const possibleTypes = generatePossibleTypes(
  introspectionResult as IntrospectionQuery
);

/**
 * Cache size configuration constants
 */
export const CACHE_CONFIG = {
  // Maximum number of cache entries before eviction
  MAX_CACHE_SIZE: 1000,

  // Memory limit in bytes (50MB)
  MEMORY_LIMIT: 50 * 1024 * 1024,

  // Default TTL for cache entries in milliseconds (30 minutes)
  DEFAULT_TTL: 30 * 60 * 1000,

  // GC threshold - trigger cleanup when cache exceeds this percentage
  GC_THRESHOLD: 0.8
} as const;
